import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

/**
 * Simple select component in saved question component
 */
class SimpleSelect extends React.Component {
    state = {
        status: 'ALL'
    };
    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
        this.props.onSelectChange(event.target.value);
    };

    render() {
        const { classes, t } = this.props;

        return (
            <form className={classes.root} autoComplete="off">
                <FormControl className={classes.formControl}>
                    <Select className="select-filter"
                            value={this.state.status}
                            onChange={this.handleChange}
                            inputProps={{
                                name: 'status',
                                id: 'status-simple',
                            }}
                    >
                        <MenuItem value="ALL">{t('all')}</MenuItem>
                        <MenuItem value="CORRECT">{t('correct')}</MenuItem>
                        <MenuItem value="INCORRECT">{t('incorrect')}</MenuItem>
                        <MenuItem value="UN_ATTEMPTED">{t('not_attempted')}</MenuItem>
                    </Select>
                </FormControl>
            </form>
        );
    }
}

SimpleSelect.propTypes = {
    classes: PropTypes.object.isRequired,
};

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: '8px 0',
        minWidth: 200,
        [theme.breakpoints.down('xs')]: {
            minWidth: '120px',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(1) * 2,
        border: "1px solid #039be5",
        width: '100%',
        padding: '0 10px',
        borderRadius: '4px'
    },
});

export default withStyles(styles)(SimpleSelect);
